// removed by extract-text-webpack-plugin
module.exports = {"block":"_3S-8lZ17jVpvnIUB3Lv1X1","tabs-sticky":"_1HBStZatO1wpLRucS0ZuOa","tabs-scroll-container":"_3pVgeyY3DfLJ-FPB36s_fk","tabs-container":"wq9SHEQBLzZVnlG8JuWoH","tabs":"_1HKr97XnUMgeO6kf--VPRz","tab":"_2YK8sQjr0HGfIpK3BQdYD2","no-results":"I1NzMzPIFA-svEopqv0fA","tab-button":"_3qUTC5IOA67Rzc_LmQsDbk","active":"_3qN_64Fd29wRdSsfdwU2wv","grayed-out":"_2T0mP4dBFY7objjSp1DLB6","search":"_2oxI1Oi-ccxCBSAIt19TkE","search-form":"_1gWonw0_xpBI2HbamsVT_8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyList/CompanyList.module.scss
// module id = 264
// module chunks = 0